import axios from "axios";

export default {

    namespaced: true,

    state: {
        searchData:[],
        searchObject: {},
        latestSearches: [],
        lastSearch:{},
        searchText: "",
        absoluteTotal:0,
        searchbarHistory:[],
        order1: "CumulativeTotalReturn1Year",
        order2: null,
        sortDir1:"DESC",
        sortDir2:"DESC",
        currentPage: 1,
        currency: "gbp",
        filters: {},
        provisionalFilters: {},
        provisionalSearch: {},
        maxMins: {},
        managerSelection:[],
        categorySelection:[],
        homeCategoryList:{},
        activeCategories:[],
        lastCategories: {},
        homeCount:null,
        quantiles:null,
        provisionalQuantile:null,
        isTextFilter1:false,
        isShowSecondOption: false,
        smallShort: {},
        currentTab: 0,
        countFiltersBasic: 0,
        countFiltersAdvance: 0,
        effectNumber: {
            f: null,
            s: null,
        },
        isBackBtnResults: false,
        lastestSelectedCategory: {},
        textInSearchBar: '',
        isNewSearchSection: false,
        typeSearch: 'search-keyword',
        isReloadSearch : false,
        platformFilter: null,
        compareBenchmarkFilter: null,
        latestSpreadBenchmarkData: null,
    },
    getters:{
        listing: state => {
            return state.searchObject
        },
        /*myHistory({state}){
            if( state.searchbarHistory.length > 0){
                return state.searchbarHistory
            }
            return state.searchbarHistory.slice(0, 5)
        }*/
    },
    actions: {
        reApiCall({state, dispatch}){
            dispatch('apiCall', state.lastSearch)
        },
        async apiCall({commit, state}, search) {
            if(search.type === undefined){
                return
            }
            let s = search.text
            if(search.code){
                s = search.code
            }
            if(search.type != "category") {
                s = encodeURIComponent(s)
            }
            let searchText = undefined;
            if(search.type=="category") {
                searchText = search.text ? search.text.trim() : undefined;
            }
            else if(search.type=="keyword") {
                searchText = search.keyword ? search.keyword.trim() : undefined;
            }

            let bodyData = {
                search: s,
                page: state.currentPage,
                native: state.currency,
                order1: state.order1,
                order2: state.order2,
                sortDir1: state.sortDir1,
                sortDir2: state.sortDir2,
                text: searchText,
                source: search.source ? search.source : undefined,
                clickOption: search.clickOption
            }
            if (state.platformFilter) {
                if (state.platformFilter.fund_exists_platform !== undefined) {
                    bodyData.fund_exists_platform = state.platformFilter.fund_exists_platform
                } else if (state.platformFilter.platform_ids && state.platformFilter.platform_ids.length) {
                    bodyData.platform_ids = state.platformFilter.platform_ids
                } else {
                    bodyData.platform_ids = []
                }
                bodyData.filter_action = state.platformFilter.filter_action
            }

            //trick with ETF/ non ETF option
            if(bodyData.order1 === "ETF / non ETF") {
                bodyData.sortDir1 = bodyData.sortDir1 === "ASC" ? "DESC" : "ASC";
            }
            if(bodyData.order2 === "ETF / non ETF") {
                bodyData.sortDir2 = bodyData.sortDir2 === "ASC" ? "DESC" : "ASC";
            }

            Object.assign(bodyData, state.filters)

            if (state.compareBenchmarkFilter) {
                bodyData.isin_benchmark = state.compareBenchmarkFilter
            } else {
                bodyData.isin_benchmark = null
            }

            await axios.post('/search/' + search.type, {
                ...bodyData
            })
            .then((response) => {
                const {...lastSearch} = search;
                commit("ADD_SEARCH_HIST", lastSearch)
                commit("ADD_LAST_SEARCH", lastSearch)
                commit("SET_SEARCH_RES", response.data)
                if (response.data.data && response.data.data.length > 0) {
                    commit("SET_LATEST_SPREAD_BENCHMARK_DATA", response.data.data[0])
                }
                // axios.get('/search/savedata', {params:
                //         {
                //             type: search.type,
                //             text: search.text,
                //             code: search.code,
                //             fund: search.fund,
                //             currency: state.currency,
                //             filters: state.filters,
                //             categories: {},
                //             sorting: {
                //                 f1:state.order1,
                //                 f2:state.order2,
                //                 d1:state.sortDir1,
                //                 d2:state.sortDir1,
                //             },
                //             page: state.currentPage
                //         }
                // })
            })
            .catch(() => {
            })

        },
        async provisionalCall({commit, state}, provisionalFilters) {
            let s = state.lastSearch.text
            if(state.lastSearch.code){
                s = state.lastSearch.code
            }

            if(state.lastSearch.type != "category"){
                s = encodeURIComponent(s)
            }

            let bodyData = {
                search: s,
                page: state.currentPage,
                native: state.currency,
                order1: state.order1,
                order2: state.order2,
                sortDir1: state.sortDir1,
                sortDir2: state.sortDir2,
                text: state.lastSearch.type==="category" ? state.lastSearch.text.trim() : undefined,
                no_track: true,
            }
            commit("SET_PROV_FILTERS",provisionalFilters)
            Object.assign(bodyData, state.filters)
            Object.assign(bodyData, provisionalFilters)
            await axios.post('/search/' + state.lastSearch.type, {
                ...bodyData
            })
                .then((response) => {
                    commit("SET_PROVISIONAL_RES", response.data)
                    //dispatch("getMaxmin")
                })
                .catch(() => {
                })

        },
        async getMaxmin({commit, state}){
            if(!state.lastSearch.type) return
            let s = state.lastSearch.text
            if(state.lastSearch.code){
                s = state.lastSearch.code
            }
            await axios.get('/search/'+state.lastSearch.type, {
                params: {
                    search: s,
                    native: this.currencyNative,
                    maxmin:true
                }
            })
                .then((response) => {
                    commit("SET_MAXMIN",response.data[0])
                })
                .catch(() => {
                })
        },
        getManagers({commit, state}) {
            if (!state.lastSearch || !state.lastSearch.type) 
                return;
            let s = state.lastSearch.text
            if (state.lastSearch.code) {
                s = state.lastSearch.code
            }
            let params = {
                search: s,
                getManagers: true
            }
            //Object.assign(params, state.filters)
            //Object.assign(params, provisionalFilters)
            axios.get('/search/' + state.lastSearch.type, {
                params: params
            })
                .then((response) => {
                    commit("SET_MANAGERLIST", response.data)
                })
                .catch(() => {
                })
        },
        getCategories({commit, state}) {
            let s = state.lastSearch.text
            if (state.lastSearch.code) {
                s = state.lastSearch.code
            }
            let params = {
                search: s,
                getCategories: true
            }
            //Object.assign(params, state.filters)
            //Object.assign(params, provisionalFilters)
            axios.get('/search/' + state.lastSearch.type, {
                params: params
            })
                .then((response) => {
                    commit("SET_CATEGORYLIST", response.data)
                })
                .catch(() => {
                })
        },
        async getCategoriesSearch({commit},params) {
            await axios.get('/search/getcats' , {
                params: params
            })
                .then((response) => {
                    commit("SET_LASTCATEGORIES", params);
                    commit("SET_HOMECATEGORYLIST", response.data.data)
                    commit("SET_HOMECOUNT", response.data.count)
                })
                .catch(() => {
                })
        },
        async getCategoriesSearchData({commit},params) {
            await axios.get('/search/getcats' , {
                params: {...params, returndata:true}
            })
                .then((response) => {
                    commit("SET_LASTCATEGORIES", params);
                    commit("SET_ACTIVECATEGORIES", response.data)
                })
                .catch(() => {
                })
        },

    },

    mutations: {
        SET_COUNT_BASIC(state, value) {
            state.countFiltersBasic = value;
        },
        SET_COUNT_ADVANCE(state, value) {
            state.countFiltersAdvance = value;
        },
        SET_SEARCH_RES(state, value) {
            state.searchData = value
        },
        SET_PROVISIONAL_RES(state, value) {
            state.provisionalSearch = value
        },
        SET_SORTING1(state, value) {
            state.order1 = value
        },
        SET_SORTING2(state, value) {
            state.order2 = value
        },
        SET_FILTERS(state, obj) {
            state.filters = {...obj}
        },
        SET_PROV_FILTERS(state, obj) {
            state.provisionalFilters = {...obj}
        },
        SET_CURRENT_PAGE(state, n) {
            state.currentPage = n
        },
        SET_MAXMIN(state, obj) {
            state.maxMins = {...obj}
        },
        SET_ABSOLUTETOTAL(state, n) {
            state.absoluteTotal = n
        },

        SET_CURRENT_TAB(state, val) {
            state.currentTab = val;
        },

        SET_SORTDIR1(state, b) {
            state.sortDir1 = b
        },
        SET_SORTDIR2(state, b) {
            state.sortDir2 = b
        },
        SET_CURRENCY(state, val) {
            state.currency = val
        },
        SET_MANAGERLIST(state, list) {
            state.managerSelection = list
        },
        SET_CATEGORYLIST(state, list) {
            state.categorySelection = list
        },
        SET_HOMECATEGORYLIST(state, list) {
            state.homeCategoryList = list
        },
        SET_ACTIVECATEGORIES(state, list) {
            state.activeCategories = list
        },
        SET_LASTCATEGORIES(state, list) {
            state.lastCategories = list
        },
        SET_SHOW_SECOND_OPTION(state, val) {
            state.isShowSecondOption = val
        },

        SET_HOMECOUNT(state, list) {
            state.homeCount = list
        },
        SET_DATA(state, obj) {
            state.search = obj
        },
        SET_IS_TXT_FILTER1(state, bool) {
            state.isTextFilter1 = bool
        },
        SET_IS_TXT_FILTER2(state, bool) {
            state.isTextFilter2 = bool
        },
        SET_PROVISIONALQUANTILES(state, list) {
            state.provisionalQuantile = list
        },
        SET_QUANTILES(state, list) {
            state.quantiles = list
        },
        SET_SMALL_SHORT(state, val) {
            state.smallShort = val;
        },
        ADD_SEARCH_HIST(state, obj) {
            state.latestSearches.unshift(obj)
            //state.latestSearches.pop()
        },
        ADD_LAST_SEARCH(state, obj) {
            state.lastSearch = obj
        },
        ADD_SEARCHBAR_HISTORY(state, obj) {
            state.searchbarHistory.unshift(obj)
            localStorage.setItem('searchbarHistory', JSON.stringify(state.searchbarHistory));
        },
        SET_EFFECT_NUMBER(state, value) {
            state.effectNumber = value;
        },
        SET_BACKBTN_RESULTS(state, bool) {
            state.isBackBtnResults = bool;
        },
        SET_LASTEST_SELECTED_CATEGORY(state, obj) {
            state.lastestSelectedCategory = obj;
        },
        SET_VALUE_SEARCH_BAR(state, text) {
            state.textInSearchBar = text;
        },
        SET_NEW_SEARCH_SECTION(state, bool) {
            state.isNewSearchSection = bool;
        },
        SET_TYPE_SEARCH(state, type) {
            state.typeSearch = type;
        },
        SET_RELOAD_SEARCH(state, bool) {
            state.isReloadSearch = bool
        },
        SET_PLATFORM_FILTER(state, value) {
            state.platformFilter = value;
        },
        SET_COMPARE_BENCHMARK_FILTER(state, value) {
            state.compareBenchmarkFilter = value;
        },
        SET_LATEST_SPREAD_BENCHMARK_DATA(state, value) {
            state.latestSpreadBenchmarkData = value;
        }
    }
}


